export default function getDefaultMeetingsLink(meetingLinks) {
  const defaultLink = meetingLinks.find(link => link.isDefaultLink);
  return defaultLink || meetingLinks[0];
}